<!-- calendar.day.html !-->
<div class="center calendarday-content">
	<!-- <ng-container #daycontainer></ng-container> !-->
	<addresscalendarday *ngIf="value && value.type == 'AddressCalendarDay'" [value]="value" (onDateClick)="dayclick($event)"></addresscalendarday>
</div>